{
  "possibleTypes": {
    "AccordionWidgetOrAnchorLinksWidgetOrAnchorWidgetOrCallToActionWidgetOrDoubleImageWidgetOrDownloadFileWidgetOrFixedCallToActionWidgetOrHeaderWidgetOrImageWidgetOrLanguageSelectorWidgetOrLocaleBlockTextWidgetOrMultiWidgetOrNutritionExplorerWidgetOrNutritionInfoWidgetOrPreviewWidgetOrQuoteWidgetOrRewardsCarouselWidgetOrVideoWidgetOrWebViewWidgetOrYoutubeWidget": [
      "AccordionWidget",
      "AnchorLinksWidget",
      "AnchorWidget",
      "CallToActionWidget",
      "DoubleImageWidget",
      "DownloadFileWidget",
      "FixedCallToActionWidget",
      "HeaderWidget",
      "ImageWidget",
      "LanguageSelectorWidget",
      "LocaleBlockTextWidget",
      "MultiWidget",
      "NutritionExplorerWidget",
      "NutritionInfoWidget",
      "PreviewWidget",
      "QuoteWidget",
      "RewardsCarouselWidget",
      "VideoWidget",
      "WebViewWidget",
      "YoutubeWidget"
    ],
    "AlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrGoogleAdSlotOrHeroOrLockedOffersOrMainHeroOrMarketingCardGroupOrMarketingTileCarouselOrMarketingTileGroupOrOffersSectionOrOurServicesOrQuestsSectionOrRecentItemsOrRewardsSectionOrRollUpTheRimSectionOrScanForRewardsOrSimpleHomePageOrTimsRewardsPointsSectionOrTrending": [
      "Alert",
      "AppDownload",
      "BrazeContentCards",
      "FanFavorites",
      "GoogleAdSlot",
      "Hero",
      "LockedOffers",
      "MainHero",
      "MarketingCardGroup",
      "MarketingTileCarousel",
      "MarketingTileGroup",
      "OffersSection",
      "OurServices",
      "QuestsSection",
      "RecentItems",
      "RewardsSection",
      "RollUpTheRimSection",
      "ScanForRewards",
      "SimpleHomePage",
      "TimsRewardsPointsSection",
      "Trending"
    ],
    "AlertOrAppDownloadOrBrazeContentCardsOrFanFavoritesOrLockedOffersOrMainHeroOrMarketingTileGroupOrOffersSectionOrOurServicesOrRecentItemsOrTrending": [
      "Alert",
      "AppDownload",
      "BrazeContentCards",
      "FanFavorites",
      "LockedOffers",
      "MainHero",
      "MarketingTileGroup",
      "OffersSection",
      "OurServices",
      "RecentItems",
      "Trending"
    ],
    "AllowRedemptionWithoutLoginOrAndOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrOrOrOrderHistoryOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions": [
      "AllowRedemptionWithoutLogin",
      "And",
      "BetweenDates",
      "BetweenTimes",
      "CartContainsPlu",
      "CartProperty",
      "CoolDown",
      "DayOfWeekBand",
      "FirstOrderOnly",
      "Limit",
      "Or",
      "OrderHistory",
      "PaymentCardType",
      "Purchase",
      "RequiresAssignment",
      "RestaurantGroupRestrictions"
    ],
    "AllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrIsStackableOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions": [
      "AllowRedemptionWithoutLogin",
      "BetweenDates",
      "BetweenTimes",
      "CartContainsPlu",
      "CartProperty",
      "CartRequirement",
      "CoolDown",
      "DayOfWeekBand",
      "FirstOrderOnly",
      "IsStackable",
      "Limit",
      "PaymentCardType",
      "Purchase",
      "RequiresAssignment",
      "RestaurantGroupRestrictions"
    ],
    "AllowRedemptionWithoutLoginOrBetweenDatesOrBetweenTimesOrCartContainsPluOrCartPropertyOrCartRequirementOrCoolDownOrDayOfWeekBandOrFirstOrderOnlyOrLimitOrPaymentCardTypeOrPurchaseOrRequiresAssignmentOrRestaurantGroupRestrictions": [
      "AllowRedemptionWithoutLogin",
      "BetweenDates",
      "BetweenTimes",
      "CartContainsPlu",
      "CartProperty",
      "CartRequirement",
      "CoolDown",
      "DayOfWeekBand",
      "FirstOrderOnly",
      "Limit",
      "PaymentCardType",
      "Purchase",
      "RequiresAssignment",
      "RestaurantGroupRestrictions"
    ],
    "AndOrBetweenTimesOrCartContainsPluOrCartPropertyOrDayOfWeekBandOrOrOrPaymentCardTypeOrPurchase": [
      "And",
      "BetweenTimes",
      "CartContainsPlu",
      "CartProperty",
      "DayOfWeekBand",
      "Or",
      "PaymentCardType",
      "Purchase"
    ],
    "BirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementDocumentRuleOrCartRequirementExclusionOrCartRequirementExclusionDocumentRuleOrChannelRestrictionsOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrExpiryDaysOrFirstOrderOnlyOrIncentiveRequirementOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrPaymentMethodOrRequiresAuthenticationOrRequiresIdAndPayOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrStoreDaypartsRuleOrSubtotalSpendOrTransactionCountOrUserCreated": [
      "BirthdayMultiplier",
      "CartLimit",
      "CartRequirement",
      "CartRequirementDocumentRule",
      "CartRequirementExclusion",
      "CartRequirementExclusionDocumentRule",
      "ChannelRestrictions",
      "CoolDown",
      "DayOfWeekBand",
      "EmailVerifiedRequired",
      "ExpiryDays",
      "FirstOrderOnly",
      "IncentiveRequirement",
      "Limit",
      "LoyaltyBetweenDates",
      "LoyaltyBetweenTimes",
      "PaymentMethod",
      "RequiresAuthentication",
      "RequiresIdAndPay",
      "RestaurantGroupRestrictions",
      "ServiceModeRestrictions",
      "StoreDaypartsRule",
      "SubtotalSpend",
      "TransactionCount",
      "UserCreated"
    ],
    "BirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementDocumentRuleOrCartRequirementExclusionOrCartRequirementExclusionDocumentRuleOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrExpiryDaysOrFirstOrderOnlyOrIsStackableOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrPaymentMethodOrRequiresAuthenticationOrRequiresIdAndPayOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated": [
      "BirthdayMultiplier",
      "CartLimit",
      "CartRequirement",
      "CartRequirementDocumentRule",
      "CartRequirementExclusion",
      "CartRequirementExclusionDocumentRule",
      "CoolDown",
      "DayOfWeekBand",
      "EmailVerifiedRequired",
      "ExpiryDays",
      "FirstOrderOnly",
      "IsStackable",
      "Limit",
      "LoyaltyBetweenDates",
      "LoyaltyBetweenTimes",
      "PaymentMethod",
      "RequiresAuthentication",
      "RequiresIdAndPay",
      "RestaurantGroupRestrictions",
      "ServiceModeRestrictions",
      "SubtotalSpend",
      "TransactionCount",
      "UserCreated"
    ],
    "BirthdayMultiplierOrCartLimitOrCartRequirementOrCartRequirementDocumentRuleOrCartRequirementExclusionOrCartRequirementExclusionDocumentRuleOrCoolDownOrDayOfWeekBandOrEmailVerifiedRequiredOrExpiryDaysOrFirstOrderOnlyOrLimitOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrLoyaltyPointsOrPaymentMethodOrRequiresAuthenticationOrRequiresIdAndPayOrRestaurantGroupRestrictionsOrServiceModeRestrictionsOrSubtotalSpendOrTransactionCountOrUserCreated": [
      "BirthdayMultiplier",
      "CartLimit",
      "CartRequirement",
      "CartRequirementDocumentRule",
      "CartRequirementExclusion",
      "CartRequirementExclusionDocumentRule",
      "CoolDown",
      "DayOfWeekBand",
      "EmailVerifiedRequired",
      "ExpiryDays",
      "FirstOrderOnly",
      "Limit",
      "LoyaltyBetweenDates",
      "LoyaltyBetweenTimes",
      "LoyaltyPoints",
      "PaymentMethod",
      "RequiresAuthentication",
      "RequiresIdAndPay",
      "RestaurantGroupRestrictions",
      "ServiceModeRestrictions",
      "SubtotalSpend",
      "TransactionCount",
      "UserCreated"
    ],
    "BirthdayRequiredOrCartRequirementOrCartRequirementDocumentRuleOrCartRequirementExclusionOrCartRequirementExclusionDocumentRuleOrCumulativeQuantityOrDayOfWeekBandOrEmailVerifiedRequiredOrExpiryDaysOrIncentiveRequirementOrLoyaltyBetweenDatesOrLoyaltyBetweenTimesOrOptInCmsRequiredOrOptInPushRequiredOrOptInSmsRequiredOrPaymentMethodOrRequiresAuthenticationOrRequiresIdAndPayOrServiceModeRestrictionsOrSubtotalSpendOrZipCodeRequired": [
      "BirthdayRequired",
      "CartRequirement",
      "CartRequirementDocumentRule",
      "CartRequirementExclusion",
      "CartRequirementExclusionDocumentRule",
      "CumulativeQuantity",
      "DayOfWeekBand",
      "EmailVerifiedRequired",
      "ExpiryDays",
      "IncentiveRequirement",
      "LoyaltyBetweenDates",
      "LoyaltyBetweenTimes",
      "OptInCmsRequired",
      "OptInPushRequired",
      "OptInSmsRequired",
      "PaymentMethod",
      "RequiresAuthentication",
      "RequiresIdAndPay",
      "ServiceModeRestrictions",
      "SubtotalSpend",
      "ZipCodeRequired"
    ],
    "BirthdayRequiredOrEmailVerifiedRequiredOrLimitOrLoyaltyBetweenDatesOrOptInCmsRequiredOrOptInPushRequiredOrOptInSmsRequiredOrRequiresAuthenticationOrRequiresIdAndPayOrUserCreatedOrZipCodeRequired": [
      "BirthdayRequired",
      "EmailVerifiedRequired",
      "Limit",
      "LoyaltyBetweenDates",
      "OptInCmsRequired",
      "OptInPushRequired",
      "OptInSmsRequired",
      "RequiresAuthentication",
      "RequiresIdAndPay",
      "UserCreated",
      "ZipCodeRequired"
    ],
    "BlockOrBlockContentImage": [
      "Block",
      "BlockContentImage"
    ],
    "BlockOrBlockContentImageOrPlaceholderField": [
      "Block",
      "BlockContentImage",
      "PlaceholderField"
    ],
    "ComboOrConfigOfferOrConfigRewardOrItemOrRewardOrSystemwideOffer": [
      "Combo",
      "ConfigOffer",
      "ConfigReward",
      "Item",
      "Reward",
      "SystemwideOffer"
    ],
    "ComboOrConfigOfferOrItemOrPickerOrSystemwideOffer": [
      "Combo",
      "ConfigOffer",
      "Item",
      "Picker",
      "SystemwideOffer"
    ],
    "ComboOrExternalLinkOrItemOrOfferOrPickerOrSection": [
      "Combo",
      "ExternalLink",
      "Item",
      "Offer",
      "Picker",
      "Section"
    ],
    "ComboOrItem": [
      "Combo",
      "Item"
    ],
    "ComboOrItemOrOfferActivationOrOfferDiscountOrOfferItemDiscountOrOfferLoyaltyActionOrPicker": [
      "Combo",
      "Item",
      "OfferActivation",
      "OfferDiscount",
      "OfferItemDiscount",
      "OfferLoyaltyAction",
      "Picker"
    ],
    "ComboOrItemOrOfferActivationOrOfferDiscountOrOfferLoyaltyActionOrPicker": [
      "Combo",
      "Item",
      "OfferActivation",
      "OfferDiscount",
      "OfferLoyaltyAction",
      "Picker"
    ],
    "ComboOrItemOrOfferActivationOrOfferDiscountOrPickerOrSwapMapping": [
      "Combo",
      "Item",
      "OfferActivation",
      "OfferDiscount",
      "Picker",
      "SwapMapping"
    ],
    "ComboOrItemOrOfferDiscountOrPicker": [
      "Combo",
      "Item",
      "OfferDiscount",
      "Picker"
    ],
    "ComboOrItemOrOfferOrPickerOrSection": [
      "Combo",
      "Item",
      "Offer",
      "Picker",
      "Section"
    ],
    "ComboOrItemOrPicker": [
      "Combo",
      "Item",
      "Picker"
    ],
    "ComboOrItemOrPickerOrProductCategory": [
      "Combo",
      "Item",
      "Picker",
      "ProductCategory"
    ],
    "ComboOrItemOrPickerOrSection": [
      "Combo",
      "Item",
      "Picker",
      "Section"
    ],
    "ConditionAllergenOrConditionItemOneOfOrConditionNutritionOrConditionParentCategory": [
      "ConditionAllergen",
      "ConditionItemOneOf",
      "ConditionNutrition",
      "ConditionParentCategory"
    ],
    "ConfigOfferOrConfigRewardOrRewardOrSystemwideOffer": [
      "ConfigOffer",
      "ConfigReward",
      "Reward",
      "SystemwideOffer"
    ],
    "CopyrightAndLanguageSelectorOrHighlightedVerticalLinkListWidgetOrHorizontalLinkListWidgetOrImageWidgetOrSocialIconsWithHeaderWidgetOrTextWidgetOrTextWidgetWithUrlOrVerticalLinkListWidgetOrVerticalLinkListWithHeaderWidgetOrWordmarkAndSocialIcons": [
      "CopyrightAndLanguageSelector",
      "HighlightedVerticalLinkListWidget",
      "HorizontalLinkListWidget",
      "ImageWidget",
      "SocialIconsWithHeaderWidget",
      "TextWidget",
      "TextWidgetWithUrl",
      "VerticalLinkListWidget",
      "VerticalLinkListWithHeaderWidget",
      "WordmarkAndSocialIcons"
    ],
    "Document": [
      "AdaptableMenuCard",
      "AdaptableMenuCardGroup",
      "AddOnSection",
      "AdminToolReleaseNotes",
      "Alert",
      "AppData",
      "AppDownload",
      "AppVersion",
      "AssistInstructionContext",
      "Badge",
      "Barcodes",
      "BrazeContentCards",
      "BuildConfiguration",
      "CartRequirementDocument",
      "CartRequirementExclusionDocument",
      "CartTotalCountdown",
      "Category",
      "CateringPageConfiguration",
      "ClaimPointsUI",
      "Combo",
      "ComboSlot",
      "ConfigOffer",
      "ConfigQuest",
      "ConfigReward",
      "ConfigTierGroup",
      "DisplayGroup",
      "EarningCalculation",
      "EmptyState",
      "FanFavorites",
      "FeatureAccount",
      "FeatureAccountDeletePage",
      "FeatureAccountForm",
      "FeatureAccountRequestInfoPage",
      "FeatureAuthCampaign",
      "FeatureBeeperModal",
      "FeatureCateringPage",
      "FeatureDisclaimers",
      "FeatureDonation",
      "FeatureExternalCampaign",
      "FeatureFoodware",
      "FeatureFooter",
      "FeatureFooterV2",
      "FeatureGeolocationMapMarkers",
      "FeatureGeolocationModal",
      "FeatureGift",
      "FeatureHomePage",
      "FeatureInvitationCode",
      "FeatureKiosk",
      "FeatureKioskHomePage",
      "FeatureKioskMenu",
      "FeatureKioskOffers",
      "FeatureKioskScreensaver",
      "FeatureLayout",
      "FeatureLocationPromo",
      "FeatureLockers",
      "FeatureLoyaltyHowItWorks",
      "FeatureMenu",
      "FeatureMobileAppConfiguration",
      "FeatureNavigation",
      "FeatureNutrition",
      "FeatureOffers",
      "FeatureOnboarding",
      "FeaturePayback",
      "FeatureQuiz",
      "FeatureScanAndPay",
      "FeatureSimplifiedLandingPage",
      "FeatureStaticImages",
      "FeatureStaticMenu",
      "Footer",
      "FrontEndConfiguration",
      "GoogleAdSlot",
      "Hero",
      "HomePageConfiguration",
      "ImageWithHeaderAndText",
      "Ingredients",
      "Item",
      "KioskAppData",
      "KioskConfiguration",
      "LinkPhysicalCardUi",
      "LockedOffers",
      "LoyaltyConfiguration",
      "LoyaltyContent",
      "LoyaltyOffersUI",
      "LoyaltyQuestsUI",
      "LoyaltyReceipts",
      "LoyaltyUI",
      "MainHero",
      "MarkerItem",
      "MarketingCard",
      "MarketingCardGroup",
      "MarketingTile",
      "MarketingTileBasic",
      "MarketingTileCarousel",
      "MarketingTileGroup",
      "MediaTag",
      "Menu",
      "Modifier",
      "ModifierMultiplier",
      "MyCode",
      "NavigationSection",
      "NutritionalSection",
      "Offer",
      "OfferActivation",
      "OfferCampaign",
      "OfferDiscount",
      "OfferGroup",
      "OfferItemDiscount",
      "OfferLoyaltyAction",
      "OfferTemplate",
      "OffersSection",
      "OpPricingRegion",
      "OurServices",
      "Picker",
      "PickerAspect",
      "PlaceholderField",
      "PosConfiguration",
      "ProductCategory",
      "QuestTemplate",
      "QuestionDetails",
      "QuestsSection",
      "RecentItems",
      "RemediationReasons",
      "ResponseDetails",
      "Restaurant",
      "RestaurantAmenity",
      "RestaurantDeliveryProvider",
      "RestaurantGroup",
      "RestaurantKioskData",
      "RestaurantPosData",
      "ResultDetails",
      "Reward",
      "RewardCategory",
      "RewardList",
      "RewardsSection",
      "RollUpTheRim",
      "RollUpTheRimSection",
      "SanityFileAsset",
      "SanityImageAsset",
      "SanityReleaseNotes",
      "SanityValidationConfiguration",
      "ScanForRewards",
      "Section",
      "SimpleHomePage",
      "StaticImage",
      "StaticPage",
      "SupportCategoryGroup",
      "SupportData",
      "SupportFaq",
      "SupportSubcategory",
      "SwapMapping",
      "SystemwideOffer",
      "SystemwidePromotion",
      "SystemwideQuest",
      "SystemwideTierGroup",
      "Tag",
      "Tier",
      "TimsRewardsPointsSection",
      "Trending",
      "Walmart"
    ],
    "FeaturedRewardsCarouselWidgetOrLoyaltyDoubleButtonWidgetOrLoyaltyGreetingWidgetOrLoyaltyHistoryWidgetOrLoyaltyLinkWidgetOrLoyaltyLogoWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyNotificationsWidgetOrLoyaltyPointsAndRewardsWidgetOrLoyaltyPointsMeterWidgetOrLoyaltyQuestsTileWidgetOrLoyaltyQuestsWidgetOrLoyaltyTiersWidgetOrRewardsListWidget": [
      "FeaturedRewardsCarouselWidget",
      "LoyaltyDoubleButtonWidget",
      "LoyaltyGreetingWidget",
      "LoyaltyHistoryWidget",
      "LoyaltyLinkWidget",
      "LoyaltyLogoWidget",
      "LoyaltyMarketingTileGroupWidget",
      "LoyaltyNotificationsWidget",
      "LoyaltyPointsAndRewardsWidget",
      "LoyaltyPointsMeterWidget",
      "LoyaltyQuestsTileWidget",
      "LoyaltyQuestsWidget",
      "LoyaltyTiersWidget",
      "RewardsListWidget"
    ],
    "ItemOrNutritionalSection": [
      "Item",
      "NutritionalSection"
    ],
    "ItemOrPickerOrSection": [
      "Item",
      "Picker",
      "Section"
    ],
    "LoyaltyBasicCardWidgetOrLoyaltyButtonArrayWidgetOrLoyaltyButtonWidgetOrLoyaltyCartWidgetOrLoyaltyImageWidgetOrLoyaltyLegacyShortCodeWidgetOrLoyaltyMarketingTileGroupWidgetOrLoyaltyPaymentMethodWidgetOrLoyaltyQRAndShortCodeWidgetOrLoyaltyQRCodeLoyaltyIdWidgetOrLoyaltyQRCodeWidgetOrLoyaltyQRScanButtonWidgetOrLoyaltyQRScanHeaderWidgetOrLoyaltyShortCodeWidgetOrLoyaltyTextWidgetOrLoyaltyTitleWidget": [
      "LoyaltyBasicCardWidget",
      "LoyaltyButtonArrayWidget",
      "LoyaltyButtonWidget",
      "LoyaltyCartWidget",
      "LoyaltyImageWidget",
      "LoyaltyLegacyShortCodeWidget",
      "LoyaltyMarketingTileGroupWidget",
      "LoyaltyPaymentMethodWidget",
      "LoyaltyQRAndShortCodeWidget",
      "LoyaltyQRCodeLoyaltyIdWidget",
      "LoyaltyQRCodeWidget",
      "LoyaltyQRScanButtonWidget",
      "LoyaltyQRScanHeaderWidget",
      "LoyaltyShortCodeWidget",
      "LoyaltyTextWidget",
      "LoyaltyTitleWidget"
    ],
    "MarketingTileOrMarketingTileBasic": [
      "MarketingTile",
      "MarketingTileBasic"
    ],
    "MarketingTileOrMarketingTileBasicOrMarketingTileListOrMarketingTilePairOrMarketingTileQuad": [
      "MarketingTile",
      "MarketingTileBasic",
      "MarketingTileList",
      "MarketingTilePair",
      "MarketingTileQuad"
    ],
    "NavigationSectionOrStaticPage": [
      "NavigationSection",
      "StaticPage"
    ],
    "NutritionItemOrNutritionItemGroup": [
      "NutritionItem",
      "NutritionItemGroup"
    ],
    "OfferGroupOrSystemwideOfferOrSystemwideTierGroup": [
      "OfferGroup",
      "SystemwideOffer",
      "SystemwideTierGroup"
    ],
    "OptInPrivacyPreferencesOrOptInSettingBooleanOrOptInSettingEmailOrOptInSettingEmailAndPushOrOptInSettingEnumOrOptInSettingPush": [
      "OptInPrivacyPreferences",
      "OptInSettingBoolean",
      "OptInSettingEmail",
      "OptInSettingEmailAndPush",
      "OptInSettingEnum",
      "OptInSettingPush"
    ],
    "OptInSettingBooleanOrOptInSettingEmailAndPushOrOptInSettingEnum": [
      "OptInSettingBoolean",
      "OptInSettingEmailAndPush",
      "OptInSettingEnum"
    ],
    "PickerOrSection": [
      "Picker",
      "Section"
    ],
    "RewardOrSystemwideOfferOrSystemwidePromotion": [
      "Reward",
      "SystemwideOffer",
      "SystemwidePromotion"
    ],
    "SanityAssistOutputFieldOrSanityAssistOutputType": [
      "SanityAssistOutputField",
      "SanityAssistOutputType"
    ]
  }
}